<template>
<div class="fluid white project-index-page mb-0 pb-5">
  <div class="elevation-3 fluid primary white--text green-pattern">
    <v-container fluid-md>
      <v-layout row wrap grid-list-md>
        <v-flex
          class="mt-5 mb-md-5"
          text-md-left
          text-xs-left
          xs12
          md4
        >
          <h1 class="fluid primary h2">
            Prototype Gallery
          </h1>
        </v-flex>
        <v-flex
          class="my-5 pt-4"
          text-md-right
          text-xs-left
          xs12
          md6
          offset-xs0
          offset-md2
        >
          <p class="fluid primary">
            Since TD Lab was established in 2014, we have created more than 300 prototypes, proof of concepts,
            and pilots - all with the goal of exploring and experimenting new ways to enhance the customer
            experience. These concepts are developed with our business partners and their learnings used to
            inform future offerings or to be further developed and scaled into new experiences.
          </p>
          <p class="fluid primary">
            Here is a collection of our most recent prototypes and experiments.
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <v-toolbar
    v-if="portfolios.length > 1"
    class="w-100 elevation-5 project-toolbar px-0 mx-0"
    fixed
  >
    <div class="w-100">
    <v-container class="py-2 hidden-md-and-up w-100 filter-button-container">
      <v-layout row wrap class="py-0">
        <v-flex class="py-0" xs12>
          <v-btn
            color="primary w-100 mx-0"
            small
            @click="filterDrawer = !filterDrawer"
          >
            <span v-if="!filterDrawer">
              Filter projects
            </span>
            <span v-if="filterDrawer">
              Hide filters
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-form ref="form" class="w-100 px-0 mx-0 hidden-sm-and-down"
      :class="{'active-filter-drawer': filterDrawer}"
    >
    <v-container class="pt-xs-0 pt-md-3 pb-1">
      <v-layout row wrap>
        <v-flex
          xs12
          md5
        >
          <v-btn-toggle
            class="w-100 project-filter-button-group elevation-2"
            v-model="projectTypes"
            mandatory
            multiple
          >
            <v-btn
              flat
              v-for="type in projectTypesMeta"
              :key="type.title"
              class="flex project-filter-button"
            >
              <span class="icon">
                {{type.icon}}
              </span>
              {{type.title}}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          xs8
          md5
          offset-md1
        >
          <v-select
            label="Project Categories"
            v-model="projectThemesSelect"
            :items="filters"
            required
            multiple
            chips
          ></v-select>
        </v-flex>
        <v-flex xs4 md1>
          <v-btn class="mt-3" @click="clear">clear</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
    </div>
  </v-toolbar>
  <div v-if="portfolios.length > 1" class="fluid">
    <v-container grid-list-md>
      <!-- <v-layout row wrap>
        <v-flex text-md-left>
          <h2>Other Projects</h2>
        </v-flex>
      </v-layout> -->
      <v-layout
        row
        wrap
        text-md-left
        class="mt-5"
      >
        <v-flex
          v-for="(project, index) in projectListDisplay"
          :key="project.uri + index"
          xl3
          md4
          sm6
        >
          <transition name="fade">
            <project-card
              v-if="typeOf(project) === 'object'"
              :project="project"
            ></project-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <div v-if="portfolios.length > 1" class="fluid">
    <transition-group name="fade" tag="div" class="fluid portfolio-group">
      <v-container
        v-for="(portfolio, index) in portfolios"
        :key="`${portfolio.uri}${index}protfolio`"
        grid-list-md
        fluid-md
        class="mb-5 white text-left"
      >
        <v-layout
          v-if="!!portfolio.projects.length"
          row
          wrap
          text-md-left
        >
          <v-flex
            class="my-5"
            xs12
            md4
            lg4
            xl3
          >
            <h2>
              {{ portfolio.title }}
            </h2>
            <p>
              {{ portfolio.description }}
            </p>
          </v-flex>
          <v-flex
            class="my-5"
            xs12
            md8
            lg8
            xl9
          >
            <v-layout
              row
              wrap
              text-md-left
            >
              <v-flex
                v-for="project in portfolio.projects"
                :key="project.uri + index"
                :class="{'d-none': !project.publish}"
                xl4
                md6
                sm6
              >
                <transition name="fade">
                  <project-card
                    v-if="typeOf(project) === 'object'"
                    :project="project"
                  ></project-card>
                </transition>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          row
          v-if="!!portfolio.projects.length"
        >
          <v-flex xs10 md8 offset-xs1 offset-md0><hr class="primary lighten-4 mt-5"></v-flex>
        </v-layout>
      </v-container>
    </transition-group>
  </div>
</div>
</template>

<style lang="scss">
.project-index-page {
  h1 {
    font-size: 3em;
  }
  .h2:after, h2:after {
    content: '—';
    display: block;
    line-height: 1em;
  }
  .green-pattern {
    z-index: 0;
    h1 {
      display: inline;
    }
  }
  .active-filter-drawer {
    display: block !important;
    flex: none;
  }
  .filter-button-container {
    flex: none;
    display: block;
  }
  .project-filter-button-group {
    background-color: transparent;
    .v-btn:before {
      background-color: transparent;
    }
    .v-btn--active:before {
      background-color: #f5f5f5 !important;
    }
    .project-filter-button {
      height: 100%;
      min-height: 50px;
      padding: 0;
      .icon {
        font-size: 1.5em;
        display: block;
        width: 100%;
        margin-bottom: 0.0125em;
      }
      .v-btn__content {
        display: block;
      }
    }
  }
  .project-toolbar {
    .v-toolbar__content {
      height: auto !important;
      z-index: 1;
    }
    position: sticky;
    height: auto !important;
  }
}
</style>

<script>
import { db } from '@/db.js'
import projectCard from '@/components/projectCard.vue'
import startCase from 'lodash/startCase'
import flattenDeep from 'lodash/flattenDeep'
import toLower from 'lodash/toLower'
import uniq from 'lodash/uniq'
import intersection from 'lodash/intersection'

export default {
  name: 'projectIndex',
  components: {
    projectCard
  },
  metaInfo: {
    meta: [
      { vmid: 'description', name: 'description', content: 'bar' }
    ]
  },
  data () {
    return {
      portfolios: [],
      projects: [],
      projectThemesSelect: null,
      filterDrawer: false,
      projectTypesMeta: [
        {
          title: 'idea',
          icon: '💡'
        },
        {
          title: 'prototype',
          icon: '💎'
        },
        {
          title: 'pilot',
          icon: '🚀'
        }
      ],
      projectTypes: [0, 1, 2]
    }
  },
  computed: {
    projectListDisplay () {
      return this.filteredProjects.length
        ? this.filteredProjects
        : this.projectList
    },
    filteredProjects () {
      let isThemeFilter = !!this.projectThemesSelect
      let isTypeFilter = this.projectTypes.length < this.projectTypesMeta.length
      let noProjects = []
      let filteredProjects = isThemeFilter || isTypeFilter
        ? this.projects
        : noProjects

      filteredProjects = filteredProjects.filter(project => {
        return !!project.publish
      })

      if (isThemeFilter) {
        filteredProjects = filteredProjects.filter(project => {
          return !!intersection(project.projectThemes, this.projectThemesSelect).length
        })
      }

      if (isTypeFilter) {
        let selectedProjectTypes = this.projectTypes.map(i => {
          return this.projectTypesMeta[i].title
        })

        filteredProjects = filteredProjects.filter(project => {
          return selectedProjectTypes.includes(project.projectType)
        })
      }

      return filteredProjects
    },
    filters: {
      get: function () {
        let projectThemes = this.projects.map(project => {
          return project.projectThemes
        })

        projectThemes = uniq(
          flattenDeep(
            projectThemes
          )
        )

        return projectThemes
      },
      set: function (newValue) {
        this.projectThemesSelect = newValue
      }
    },
    projectList () {
      let projectList = this.projects
      let uriList = this.portfolios.map(portfolio => {
        return portfolio.projects.map(project => {
          return project.uri
        })
      })
      let uriListFlat = flattenDeep(uriList)

      let returnVal = projectList.filter(project => {
        return !uriListFlat.includes(project.uri) && project.publish
      })

      return returnVal
    }
  },
  methods: {
    typeOf: (project) => {
      return typeof (project)
    },
    clear () {
      this.projectThemesSelect = null
      this.projectTypes = [0, 1, 2]
    }
  },
  created () {
    let vm = this

    vm.$nextTick(() => {
      let dynamicType = vm.$route.query['type'] || '0,1,2' // 0, 1, 2
      let dynamicThemes = vm.$route.query['themes'] || '' // technology,credit%20cards

      if (dynamicType) {
        dynamicType = dynamicType.split(',').map(val => {
          return parseInt(val)
        }).filter(val => {
          return !!val || val === 0
        })
      }

      if (dynamicThemes) {
        dynamicThemes = dynamicThemes.split(',').filter(val => {
          return val !== ''
        }).map(val => {
          return startCase(
            toLower(
              val
            )
          )
        })
      }

      vm.projectTypes = dynamicType
      vm.projectThemesSelect = dynamicThemes
    })
  },
  firestore: {
    portfolios: db.collection('portfolios'),
    projects: db.collection('projects')
  }
}
</script>
